<template>
  <div v-if="browserMap && osMap && engineMap">
    <div v-if="errorComponent">
      <div>
        <div>
          <Component
            :is="errorComponent"
            v-if="errorComponent"
            :key="componentKey"
            :browser-name="browser.browser.name"
            @check="check"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { toRefs, computed } from '@vue/composition-api';
import OtherError from './PermissionTexts/OtherError.vue';
import NotConnected from './PermissionTexts/NotConnected.vue';
import NotAllowedBlink from './PermissionTexts/NotAllowedBlink.vue';
import NotAllowedMacOsSafari from './PermissionTexts/NotAllowedMacOsSafari.vue';
import NotAllowedFirefox from './PermissionTexts/NotAllowedFirefox.vue';
import NotAllowedAndroidChrome from './PermissionTexts/NotAllowedAndroidChrome.vue';
import BlockedAtSystemLevelMacOs from './PermissionTexts/BlockedAtSystemLevelMacOs.vue';
import NotReadableErrorVideoWindows from './PermissionTexts/NotReadableErrorVideoWindows.vue';
import NotReadableErrorAudioWindows from './PermissionTexts/NotReadableErrorAudioWindows.vue';
import WindowsFirefoxNoSound from './PermissionTexts/NoSoundWindowsFirefox.vue';
import NotAllowedBlinkWindowsSystem from './PermissionTexts/NotAllowedBlinkWindowsSystem.vue';
import useBrowser from '../../compositions/useBrowser';

export default {
  name: 'Permission',
  components: {
    NotAllowedBlinkWindowsSystem,
    NotAllowedAndroidChrome,
    NotAllowedFirefox,
    NotAllowedMacOsSafari,
    NotAllowedBlink,
    NotReadableErrorVideoWindows,
    NotReadableErrorAudioWindows,
    WindowsFirefoxNoSound,
    BlockedAtSystemLevelMacOs,
    OtherError,
    NotConnected,
  },
  props: {
    error: {
      required: true,
    },
  },
  setup(props, { emit }) {
    const { error } = toRefs(props);
    const componentKey = computed(() => Date.now());
    const {
      browser, browserMap, osMap, engineMap,
    } = useBrowser();

    function check() {
      emit('check');
      window.location.reload();
    }

    const errorComponent = computed(() => {
      switch (error.value.name.toLowerCase()) {
        case 'notallowederror': {
          if (browser.value.browser.name === browserMap.value.firefox) {
            return 'NotAllowedFirefox';
          } if (browser.value.os.name === osMap.value.MacOS && error.value.message.toLowerCase().indexOf('system') > -1) {
            return 'BlockedAtSystemLevelMacOs';
          } if (browser.value.os.name === osMap.value.Windows && error.value.message.toLowerCase().indexOf('system') > -1) {
            return 'NotAllowedBlinkWindowsSystem';
          } if (browser.value.browser.name === browserMap.value.safari && browser.value.os.name === osMap.value.MacOS) {
            return 'NotAllowedMacOsSafari';
          } if (browser.value.os.name === osMap.value.Android && browser.value.browser.name === browserMap.value.chrome) {
            return 'NotAllowedAndroidChrome';
          } if (browser.value.engine.name === engineMap.value.Blink) {
            return 'NotAllowedBlink';
          }
          return 'OtherError';
        }
        case 'notreadableerror': {
          if (browser.value.os.name === osMap.value.Windows && error.value.message.toLowerCase().indexOf('video') > -1) {
            return 'NotReadableErrorVideoWindows';
          } if (browser.value.os.name === osMap.value.Windows && error.value.message.toLowerCase().indexOf('audio') > -1) {
            return 'NotReadableErrorAudioWindows';
          }
          return 'OtherError';
        }
        case 'nosound': {
          if (browser.value.os.name === osMap.value.Windows && browser.value.browser.name === browserMap.value.firefox) {
            return 'WindowsFirefoxNoSound';
          }
          return 'OtherError';
        }
        case 'notfounderror': {
          if (browser.value.browser.name === browserMap.value.firefox && browser.value.os.name === osMap.value.MacOS) {
            return 'BlockedAtSystemLevelMacOs';
          }
          return 'NotConnected';
        }
        default: {
          return 'OtherError';
        }
      }
    });

    return {
      browser,
      browserMap,
      osMap,
      engineMap,
      check,
      errorComponent,
      componentKey,
    };
  },
};
</script>

<style scoped>

</style>

<i18n locale="en" lang="yaml">
other: Your camera is unavailable. Please try another device.
notConnected: It looks like your camera is not connected. Please connect your camera.
</i18n>

<i18n locale="ru" lang="yaml">
other: Ваша камера недоступна. Воспользуйтесь другим устройством.
notConnected: Похоже, что ваша камера не подключена. Пожалуйста подключите камеру.
</i18n>
